class deepLink {
    constructor() {
        this.init();
        
    }

    init() {
        // console.log('loaded deeplink');
    }// init

    static create(item) {
        if (item) {
        const id = item.getAttribute('id');
        if (id) {
            const url = new URL(window.location.href);
            url.searchParams.set('video', id);
            window.history.replaceState({}, '', url);
        }
        }
    }

    static remove(param){
        const url = new URL(window.location.href);
        url.searchParams.delete(param);
        window.history.replaceState({}, '', url);
    }

    static simulateClick(trigger) {

        const event = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
        });
        trigger.dispatchEvent(event);

    }

    static openDeepLink(param) {

        if ( window.location.search ){
                
            const params = new URLSearchParams(window.location.search);
        
            if ( params.get( param ) ){
            
                if ( document.getElementById(`${params.get( param )}`) ) {

                    const card = document.getElementById(`${params.get( param )}`);
                        
                    // Trigger the modal
                    if( card.classList.contains('video-module') ){
                        let anchor_trigger = card;
                        // This forces a click on load
                        this.simulateClick( anchor_trigger );
                    }

                }
            }// if param
        }
        return {};
    }
}

export { deepLink };